import {cornering, corneringType} from '../css'

const
    type = corneringType,
    radius = value => cornering(value)

export {radius, type}
